import React from "react";
import { ContentWrapper } from "./styles";
import Patient from "../../../../Models/Patient";
import CompWellnessPatient from "../../../../Models/CompWellnessPatient";
import { OutstandingPatientsTable } from './Components/OutstandingPatientsTable';
import { AppModeConfig } from "../../../../AppModes/AppModeConfig";

interface OutstandingPatientsTabProps {
    lumiPatients: Patient[],
    compWellnessPatients: CompWellnessPatient[],
    appModeConfig: AppModeConfig
}

const OutstandingPatientsTab = ({ lumiPatients, compWellnessPatients, appModeConfig }: OutstandingPatientsTabProps) => {

    return (
        <ContentWrapper>
            <OutstandingPatientsTable outstandingLumiPatients={lumiPatients} outstandingCompWellnessPatients={compWellnessPatients} appModeConfig={appModeConfig} />
        </ContentWrapper>
    );

}

export default OutstandingPatientsTab;